import React from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import Group from "../../../ServicosAcolhimento/Visualizar/Group";
import { useEffect, useState } from "react";
import CriancaService from "../../../../../main/services/CriancaService";

import { TableEducacao } from "../../../../components/TableEducacao";
import { IconeDownload } from "../../../../components/IconeDownload";
import LoadingSpinner from "../../../../components/LoadingSpinner";
import { createCustomFile } from "../../../../utils/createCustomFile";
import { useHistory, useLocation } from "react-router";
import { useFormikContext } from "formik";

export const VisualizarPageSaude = ({
  id,
  setIsTrueVisualizar,
  setInitialValues,
  url,
}) => {
  const [data, setData] = useState("");
  const [loading, setLoading] = useState(true);
  const history = useHistory();
  const { setFieldValue } = useFormikContext();

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const idAnexo = searchParams.get("idAnexo");
  const idAba = searchParams.get("idAba");
  const idTipoPendencia = searchParams.get("idTipoPendencia");

  useEffect(() => {
    setLoading(true);
    CriancaService.getCriancaSaude(id)
      .then((res) => {
        if (res.data) {
          const formatedDeficiencia = res.data.deficiencias.map((item) => {
            return {
              idTipoDeficiencia: item.idTipoDeficiencia,
              descricaoTipoDeficiencia: item.descricaoTipoDeficiencia,
            };
          });

          const deficiencias = [formatedDeficiencia];

          const tratamentos = res.data.tratamentos.map((tratamento) => {
            if (tratamento.laudoMedico) {
              const fakeFile = createCustomFile(
                [tratamento.laudoMedico.arquivoBase64],
                tratamento.laudoMedico.arquivoNome,
                {
                  type: tratamento.laudoMedico.arquivoTipo,
                  idAnexo: tratamento.laudoMedico.idAnexo
                    ? tratamento.laudoMedico.idAnexo
                    : 0,
                }
              );

              return {
                ...tratamento,
                doenca: {
                  idDoenca: tratamento.doenca.id,
                  descricaoDoenca: tratamento.doenca.descricao,
                },
                fazTratamento: tratamento.fazTratamento || "N",
                laudoMedico: fakeFile,
              };
            } else {
              return {
                ...tratamento,
                doenca: {
                  idDoenca: tratamento.doenca.id,
                  descricaoDoenca: tratamento.doenca.descricao,
                },
                fazTratamento: tratamento.fazTratamento || "N",
              };
            }
          });

          const anexoCartaoVacinacao = res.data.anexoCartaoVacinacao
            ? createCustomFile(
                [res.data.anexoCartaoVacinacao.arquivoBase64],
                res.data.anexoCartaoVacinacao.arquivoNome,
                {
                  type: res.data.anexoCartaoVacinacao.arquivoTipo,
                  idAnexo: res.data.anexoCartaoVacinacao.idAnexo || 0,
                }
              )
            : null;

          setInitialValues({
            deficiencias: deficiencias,
            tratamentos: tratamentos,
            medicacaoContinua: res.data.medicacaoContinua
              ? res.data.medicacaoContinua
              : "",
            possuiDeficiencia: res.data.possuiDeficiencia,
            possuiProblemasSaude: res.data.possuiProblemasSaude,
            cartaoVacinacao: res.data.cartaoVacinacao,
            anexoCartaoVacinacao: anexoCartaoVacinacao,
          });

          setFieldValue("tratamentos", tratamentos);

          setData(res.data);

          if (url.includes("editar")) {
            setIsTrueVisualizar(false);
          } else {
            setIsTrueVisualizar(true);
          }
        } else {
          setIsTrueVisualizar(false);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        let path = `/crianca/visualizar-saude/${id}`;
        path += idAnexo
          ? `?idAnexo=${idAnexo}`
          : idAba && idTipoPendencia
          ? `?idAba=${idAba}&idTipoPendencia=${idTipoPendencia}`
          : "";
        history.push(path);
        setIsTrueVisualizar(false);
        setLoading(false);
      });
  }, [
    id,
    url,
    setInitialValues,
    history,
    setIsTrueVisualizar,
    setFieldValue,
    idAnexo,
    idAba,
    idTipoPendencia,
  ]);

  const getLaudoMedico = (idCrianca, idSaudeDoenca) => {
    CriancaService.getLaudoMedicoSaudeDownload(idCrianca, idSaudeDoenca)
      .then((res) => {
        const downloadUrl = res.config.url;
        window.open(downloadUrl, "_blank");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getCartaoVacinacao = (idAnexo, option) => {
    CriancaService.getAnexo(idAnexo, option)
      .then((res) => {
        if (option === "download") {
          const downloadUrl = res.config.url;
          window.open(downloadUrl, "_blank");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const columns = [
    {
      Header: "Problema de Saúde",
      accessor: "doenca",
      Cell: (props) => {
        const doenca = props?.value;

        return <span>{doenca.descricao ? doenca.descricao : ""}</span>;
      },
    },
    {
      Header: "Faz Algum Tratamento de Saúde?",
      accessor: "fazTratamento",
      Cell: (props) => {
        const tratamento =
          props?.value === "S"
            ? "Sim"
            : props?.value === "T"
            ? "Sim (Temporário)"
            : props?.value === "P"
            ? "Sim (Permanente)"
            : "Não";

        return (
          <Flex justifyContent={"center"}>
            {tratamento ? tratamento : "Sim"}
          </Flex>
        );
      },
    },
    {
      Header: "Laudo Médico",
      accessor: (row) => {
        return row;
      },
      Cell: (props) => {
        const idSaudeDoenca = props?.value?.idSaudeDoenca;
        const laudo = props?.value?.laudoMedico;

        return (
          <Flex justifyContent={"center"}>
            {laudo ? (
              <button
                type="button"
                onClick={() => getLaudoMedico(id, idSaudeDoenca)}
              >
                <IconeDownload />
              </button>
            ) : (
              ""
            )}
          </Flex>
        );
      },
    },
  ];

  return !loading ? (
    <Group title="Saúde">
      <Flex mt="17px" direction={"column"} gap="18px">
        <Flex border="solid 1px #DDEBEA" px={2} py={4} gap={2}>
          <Text as="b">Possui Deficiência?</Text>
          <Text>
            {data.possuiDeficiencia === "S"
              ? "Sim. " +
                (data.deficiencias.length === 0
                  ? ""
                  : data.deficiencias.length === 1
                  ? data.deficiencias[0].descricaoTipoDeficiencia
                  : data.deficiencias.length === 2
                  ? `${data.deficiencias[0].descricaoTipoDeficiencia} e ${data.deficiencias[1].descricaoTipoDeficiencia}`
                  : `${data.deficiencias
                      .map((item) => item.descricaoTipoDeficiencia)
                      .slice(0, -1)
                      .join(", ")} e ${
                      data.deficiencias[data.deficiencias.length - 1]
                        .descricaoTipoDeficiencia
                    }`)
              : "Não"}
          </Text>
        </Flex>
        <Flex border="solid 1px #DDEBEA" px={2} py={4} gap={2}>
          <Text as="b">Possui Algum Problema de Saúde?</Text>
          <Text>{data.possuiProblemasSaude === "S" ? "Sim. " : "Não"}</Text>
        </Flex>

        {data?.possuiProblemasSaude === "S" ? (
          <>
            {data.tratamentos && data.tratamentos.length > 0 && (
              <TableEducacao
                saude={true}
                columns={columns}
                data={data.tratamentos}
              />
            )}
          </>
        ) : (
          ""
        )}

        <Flex
          justifyContent={"space-between"}
          border="solid 1px #DDEBEA"
          px={2}
          py={4}
        >
          <Flex gap={2}>
            <Text as="b">Possui Cartão de Vacinação?</Text>
            <Text>
              {data?.cartaoVacinacao === "S"
                ? "Sim"
                : data?.cartaoVacinacao === "N"
                ? "Não"
                : "Sem Informação"}
            </Text>
          </Flex>
          <Flex></Flex>
          <Flex gap={4} mr={{ base: "15%", xl: "15.5%" }} h={18}>
            <Text as="b"> Baixar Cartão de Vacinação</Text>
            {!!data?.anexoCartaoVacinacao ? (
              <button
                type="button"
                onClick={() =>
                  getCartaoVacinacao(
                    data?.anexoCartaoVacinacao?.idAnexo,
                    "download"
                  )
                }
              >
                <IconeDownload />
              </button>
            ) : (
              ""
            )}
          </Flex>
        </Flex>

        {data?.possuiProblemasSaude === "S" ? (
          <Flex border="solid 1px #DDEBEA" px={2} py={4} gap={2}>
            <Text as="b">Usa Medicação Contínua?</Text>
            <Text>{data.medicacaoContinua === "S" ? "Sim" : "Não"}</Text>
          </Flex>
        ) : (
          ""
        )}
      </Flex>
    </Group>
  ) : (
    <Box mt={4}>
      <LoadingSpinner />
    </Box>
  );
};
